<div
  #toast
  (click)="dismiss()"
  *ngIf="toast"
  [ngClass]="{
    successToast: notificationType === notificationTypesInTheUI.success,
    failureToast: notificationType === notificationTypesInTheUI.failure,
  }"
  id="toast"
>
  <div class="row">
    <div
      *ngIf="notificationType === notificationTypesInTheUI.success"
      class="col-auto"
    >
      <i class="fa fa-check fa-2x"></i>
    </div>
    <div
      *ngIf="notificationType === notificationTypesInTheUI.failure"
      class="col-auto notification-padding-top"
    >
      <i class="fa fa-circle-o fa-lg circle-position"></i>
      <i class="fa fa-exclamation exclamation-position"></i>
    </div>
    <div *ngIf="!messageIsHTML" class="col notification-padding-top">
      {{ message }}
    </div>
    <div
      *ngIf="messageIsHTML"
      [innerHTML]="message"
      class="col notification-padding-top"
    ></div>
  </div>
</div>
